import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Announcementslider from "./Announcementslider";
import CustomNavbar from "./CustomPermissions/CustomNavbar";
import { getApiUrl, API_ENDPOINTS, API_BASE_URL } from "../config/api";
import { Button, Card, Badge } from "./common";

function UserView() {
  const [data, setData] = useState(null);
  const location = useLocation();
  const { state } = location;
  const [userPermissions, setUserPermissions] = useState([]);
  const [monthlyRecords, setMonthlyRecords] = useState([]);
  const [pipelineAndTurnedUp, setPipelineAndTurnedUp] = useState(0);
  const [pipelineUnique, setPipelineUnique] = useState(0);
  const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [username, setUsername] = useState("");
  const [id, setId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [candidateList, setCandidateList] = useState([]);
  const navigate = useNavigate();
  const [userDefinedPermissions, setUserDefinedPermissions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (localStorage.getItem("access_token") !== null) {
      fetchUserData();
    }
    if (state && state.userPermissions) {
      setUserPermissions(state.userPermissions);
    }
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await fetch(getApiUrl("/GetUserDatafromUsername/"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      if (!response.ok) throw new Error("Network response was not ok");
      const data = await response.json();
      setId(data.records.id);
      setData(data.records);
      setName(data.records.name);
      setImage(data.records.image);
      setUsername(data.records.username);
      setCandidateList(data.all_entry);
      setMonthlyRecords(data.monthly_records);
      setPipelineAndTurnedUp(data.pipelineandturnedup[0].pipline);
      setPipelineUnique(data.pipelineandturnedup[0].pipeline_unique || 0);
      const storedPermissions2 = JSON.parse(localStorage.getItem("user_defined_permissions")) || [];
      setUserDefinedPermissions(storedPermissions2);
      setIsLoading(false);
    } catch (error) {
      console.error("Fetch error:", error);
      setIsLoading(false);
    }
  };

  const openCreateModal = () => {
    if (!id) {
      alert("Please wait for your profile to load before creating a record.");
      return;
    }
    setSelectedRecord(null);
    setShowModal(true);
    // document.getElementsByClassName('userviewmodal')[0].style.display = 'none';
    // document.getElementsByClassName('userview-modal')[0].style.display = 'none';

  };

  const openEditModal = (record) => {
    setSelectedRecord(record);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRecord(null);
  };

  const handleSave = async () => {
    try {
      if (!id) {
        alert("Please wait for your profile to load before creating a record.");
        return;
      }
      const formData = new FormData();
      formData.append("id", id);

      if (selectedRecord) {
        formData.append("candidate_id", selectedRecord.id);
        formData.append("candidate_name", document.getElementById("candidateName").value);
        formData.append("speciality", document.getElementById("speciality").value);
        formData.append("hospital", document.getElementById("hospital").value);
        formData.append("city", document.getElementById("city").value);
        formData.append("state", document.getElementById("state").value);
        formData.append("remark", document.getElementById("remark").value || "No remarks");
        formData.append("user_rec", id);
        formData.append("status", document.getElementById("status").value);
        formData.append("expected_revenue", document.getElementById("expected_revenue").value);
        formData.append("revenue", document.getElementById("revenue").value);
      } else {
        formData.append("candidate_name", document.getElementById("candidateName").value);
        formData.append("speciality", document.getElementById("speciality").value);
        formData.append("hospital", document.getElementById("hospital").value);
        formData.append("city", document.getElementById("city").value);
        formData.append("state", document.getElementById("state").value);
        formData.append("remark", document.getElementById("remark").value || "No remarks");
        formData.append("status", document.getElementById("status").value);
        formData.append("expected_revenue", document.getElementById("expected_revenue").value);
        formData.append("revenue", document.getElementById("revenue").value);
        formData.append("user_rec", id);
        const imageInput = document.getElementById("image");
        if (imageInput && imageInput.files.length > 0) {
          formData.append("image", imageInput.files[0]);
        }
      }

      const response = await fetch(getApiUrl(API_ENDPOINTS.UPDATE_RECORD), {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || errorData.detail || "Failed to save record");
      }
      closeModal();
      fetchUserData();
    } catch (error) {
      console.error("Error saving record:", error);
      alert(`Error: ${error.message}`);
    }
  };

  const getCookie = (name) => {
    let cookieValue = null;
    if (document.cookie && document.cookie !== "") {
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.substring(0, name.length + 1) === name + "=") {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  };

  const confirmDelete = (candidateId) => {
    if (window.confirm("Are you sure you want to delete this candidate record?")) {
      fetch(getApiUrl(`/Candidatedetail/${candidateId}/delete/`), {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie("csrftoken"),
          "Authorization": `Bearer ${localStorage.getItem("access_token")}`,
        },
      })
        .then((response) => {
          if (response.ok) {
            setCandidateList((prev) => prev.filter((r) => r.id !== candidateId));
            alert("Record deleted successfully.");
            fetchUserData();
          } else {
            response.json().then((data) => {
              alert(`Error: ${data.detail || "Failed to delete record."}`);
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
          alert("An unexpected error occurred while deleting the record.");
        });
    }
  };

  const getStatusVariant = (status) => {
    const variants = {
      selected: "success",
      pipeline: "warning",
      backout: "danger",
      turned_up: "info",
      joined: "success",
    };
    return variants[status] || "default";
  };

  return (
    <div className="flex userviewmodal min-h-screen bg-slate-50">
      <CustomNavbar />

      <main className="flex-1 flex flex-col min-w-0 userviewmain">
        <Announcementslider />

        <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-auto">
          {isLoading ? (
            <div className="flex items-center justify-center h-full">
              <div className="text-center">
                <div className="w-16 h-16 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                <p className="text-slate-600 text-lg font-medium">Loading your dashboard...</p>
              </div>
            </div>
          ) : (
            <div className="max-w-7xl mx-auto space-y-6">
              {/* Header Card */}
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-slate-200">
                <div className="bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 px-6 py-2 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-32 -mt-32"></div>
                  <div className="absolute bottom-0 left-0 w-48 h-48 bg-white opacity-5 rounded-full -ml-24 -mb-24"></div>


                  <div className="relative z-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                    <div>
                      <h1 className="text-2xl md:text-3xl font-bold text-black mb-2">
                        Welcome back, {name || "User"}! 👋
                      </h1>
                      <p className="text-indigo-100 text-sm md:text-base">
                        Manage your candidates and track performance
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-3">
                      <button
                        onClick={openCreateModal}
                        className="inline-flex items-center gap-2 bg-white text-indigo-600 hover:bg-indigo-50 px-5 py-2.5 rounded-xl font-semibold shadow-lg transition-all duration-200 hover:shadow-xl text-sm"
                      >
                        <span>➕</span>
                        <span>Upload Candidate</span>
                      </button>
                      <Link to="/UserCandidateListView">
                        <button className="inline-flex items-center gap-2 bg-indigo-800/50 hover:bg-indigo-800/70 px-5 py-2.5 rounded-xl font-semibold shadow-lg transition-all duration-200 border border-indigo-400/30 text-sm">
                          <span>📋</span>
                          <span>All Candidates</span>
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>

                {/* Profile Section */}
                <div className="px-6 py-6 bg-gradient-to-b from-slate-50 to-white">
                  <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                    <div className="relative -mt-14 sm:-mt-16 flex-shrink-0">
                      {image ? (
                        <img
                          src={`${API_BASE_URL}${image}`}
                          className="w-24 h-24 sm:w-28 sm:h-28 rounded-2xl object-cover border-4 border-white shadow-xl"
                          alt={name || "User"}
                        />
                      ) : (
                        <div className="w-24 h-24 sm:w-28 sm:h-28 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center border-4 border-white shadow-xl">
                          <span className="text-3xl sm:text-4xl text-white font-bold">
                            {name ? name.charAt(0).toUpperCase() : "?"}
                          </span>
                        </div>
                      )}
                      <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-emerald-500 rounded-full border-3 border-white shadow-md"></div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h2 className="text-xl sm:text-2xl font-bold text-slate-800 truncate">{name || "User Name"}</h2>
                      <p className="text-slate-500 font-medium mb-3">@{username || "username"}</p>
                      <div className="flex flex-wrap gap-2">
                        <span className="inline-flex items-center gap-1.5 bg-indigo-100 text-indigo-700 px-3 py-1.5 rounded-lg text-xs font-semibold">
                          <span>👤</span> HR Associate
                        </span>
                        <span className="inline-flex items-center gap-1.5 bg-emerald-100 text-emerald-700 px-3 py-1.5 rounded-lg text-xs font-semibold">
                          <span>✅</span> Active
                        </span>
                        {data?.designation_name && (
                          <span className="inline-flex items-center gap-1.5 bg-purple-100 text-purple-700 px-3 py-1.5 rounded-lg text-xs font-semibold">
                            <span>🏢</span> {data.designation_name}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
                {[
                  { label: "Resume Forwarded", value: monthlyRecords[0]?.resume_forwarded || 0, icon: "📨", gradient: "from-blue-500 to-blue-600" },
                  { label: "Pipeline", value: `${pipelineUnique}/${pipelineAndTurnedUp}`, icon: "⏳", gradient: "from-amber-500 to-orange-500" },
                  { label: "Selected", value: monthlyRecords[0]?.selected || 0, icon: "✅", gradient: "from-emerald-500 to-green-600" },
                  { label: "Expected Revenue", value: `₹${monthlyRecords[0]?.expected_revenue || 0}L`, icon: "💰", gradient: "from-violet-500 to-purple-600" },
                  { label: "Revenue", value: `₹${monthlyRecords[0]?.revenue || 0}L`, icon: "💸", gradient: "from-indigo-500 to-blue-600" },
                ].map((stat, idx) => (
                  <div key={idx} className={`bg-gradient-to-br ${stat.gradient} rounded-xl p-4 shadow-lg`}>
                    <div className="flex items-center justify-between">
                      <div className="min-w-0">
                        <p className=" text-xs sm:text-sm font-medium truncate">{stat.label}</p>
                        <p className=" text-2xl sm:text-3xl font-bold mt-1">{stat.value}</p>
                      </div>
                      <div className="bg-white/20 rounded-xl p-2.5 flex-shrink-0">
                        <span className="text-xl sm:text-2xl">{stat.icon}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Performance Table */}
              <Card shadow="lg" className="border-l-4 border-indigo-500">
                <div className="mb-4">
                  <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                    <span className="text-xl">📊</span> Performance Details
                  </h3>
                  <p className="text-slate-500 text-sm">Detailed breakdown of your monthly performance</p>
                </div>
                <div className="overflow-x-auto -mx-4 sm:mx-0">
                  <div className="inline-block min-w-full align-middle">
                    <table className="min-w-full">
                      <thead>
                        <tr className="bg-gradient-to-r from-indigo-600 to-purple-600">
                          {["📨 Forwarded", "⏳ Pipeline", "👥 Turned Up", "✅ Selected", "🤝 Joined", "❌ Backout", "💰 Exp. Revenue", "💸 Revenue"].map((h, i) => (
                            <th key={i} className="px-4 py-3 text-center text-white text-xs sm:text-sm font-semibold whitespace-nowrap">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {monthlyRecords.map((record) => (
                          <tr key={record.id} className="hover:bg-slate-50 transition-colors">
                            <td className="px-4 py-4 text-center">
                              <span className="text-xl sm:text-2xl font-bold text-blue-600">{record.resume_forwarded || 0}</span>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <Badge variant="warning" size="lg">{pipelineUnique}/{pipelineAndTurnedUp}</Badge>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <span className="text-xl sm:text-2xl font-bold text-indigo-600">{record.turned_up || 0}</span>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <Badge variant="success" size="lg">{record.selected || 0}</Badge>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <Badge variant="success" size="lg">{record.joined || 0}</Badge>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <span className="text-xl sm:text-2xl font-bold text-red-500">{record.backout || 0}</span>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <span className="text-xl sm:text-2xl font-bold text-emerald-600">
                                ₹{isNaN(record.expected_revenue) ? 0 : parseFloat(record.expected_revenue).toFixed(2)}
                              </span>
                            </td>
                            <td className="px-4 py-4 text-center">
                              <span className="text-xl sm:text-2xl font-bold text-green-600">
                                ₹{isNaN(record.revenue) ? 0 : parseFloat(record.revenue).toFixed(2)}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Card>

              {/* Candidates Table */}
              <Card shadow="lg" className="border-l-4 border-violet-500">
                <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4">
                  <div>
                    <h3 className="text-lg font-bold text-slate-800 flex items-center gap-2">
                      <span className="text-xl">📋</span> My Candidates
                    </h3>
                    <p className="text-slate-500 text-sm">All candidates you've added this month</p>
                  </div>
                  <Button variant="success" size="md" icon="➕" onClick={openCreateModal} style={{ backgroundColor: "#007bff", color: "black" }}>
                    Add Candidate
                  </Button>
                </div>
                <div className="overflow-x-auto -mx-4 sm:mx-0">
                  <div className="inline-block min-w-full align-middle">
                    <table className="min-w-full">
                      <thead>
                        <tr className="bg-gradient-to-r from-violet-600 to-indigo-600">
                          {["#", "👤 Candidate", "🏥 Speciality", "🏥 Hospital", "🌆 City", "📍 State", "💰 Exp. Revenue", "💰 Revenue", "📊 Status", "⚙️ Actions"].map((h, i) => (
                            <th key={i} className="px-3 py-3 text-center text-white text-xs sm:text-sm font-semibold whitespace-nowrap">{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {candidateList.map((record, index) => (
                          <React.Fragment key={record.id}>
                            <tr className="hover:bg-slate-50 transition-colors">
                              <td className="px-3 py-3 text-center text-sm text-slate-600">{index + 1}</td>
                              <td className="px-3 py-3 text-center text-sm font-medium text-slate-800 whitespace-nowrap">{record.candidate_name}</td>
                              <td className="px-3 py-3 text-center text-sm text-slate-600 whitespace-nowrap">{record.speciality}</td>
                              <td className="px-3 py-3 text-center text-sm text-slate-600 whitespace-nowrap">{record.hospital}</td>
                              <td className="px-3 py-3 text-center text-sm text-slate-600 whitespace-nowrap">{record.city}</td>
                              <td className="px-3 py-3 text-center text-sm text-slate-600 whitespace-nowrap">{record.state}</td>
                              <td className="px-3 py-3 text-center text-sm font-bold text-blue-600 whitespace-nowrap">₹{record.status === 'selected' ? ((parseFloat(record.expected_revenue) > 0 ? record.expected_revenue : record.revenue) || 0) : 0} lac</td>
                              <td className="px-3 py-3 text-center text-sm font-bold text-emerald-600 whitespace-nowrap">₹{record.status === 'joined' ? (record.revenue || 0) : 0} lac</td>
                              <td className="px-3 py-3 text-center">
                                <Badge variant={getStatusVariant(record.status)}>{record.status}</Badge>
                              </td>
                              <td className="px-3 py-3 text-center">
                                <div className="flex items-center justify-center gap-2">
                                  <Button
                                    variant="secondary"
                                    size="sm"
                                    onClick={() => setExpandedRowId(expandedRowId === record.id ? null : record.id)}
                                    style={{ backgroundColor: "#007bff", color: "black" }}
                                  >
                                    {expandedRowId === record.id ? "Hide" : "Show"}
                                  </Button>
                                  <Button variant="primary" size="sm" icon="✏️" onClick={() => openEditModal(record)}>
                                    <span style={{ color: "black" }}>Edit</span>
                                  </Button>
                                </div>
                              </td>
                            </tr>
                            {expandedRowId === record.id && (
                              <tr className="bg-slate-50">
                                <td colSpan="9" className="px-6 py-4">
                                  <div className="space-y-2 text-sm">
                                    <p><strong className="text-slate-700">Remark:</strong> <span className="text-slate-600">{record.remark || "N/A"}</span></p>
                                    <p><strong className="text-slate-700">Date Entered:</strong> <span className="text-slate-600">{record.date_entered}</span></p>
                                    <div className="flex gap-2 pt-2">
                                      <button
                                        className="px-4 py-2 bg-red-500 hover:bg-red-600 text-white text-sm font-medium rounded-lg transition-colors"
                                        onClick={() => confirmDelete(record.id)}
                                      >
                                        Delete
                                      </button>
                                      <button
                                        className="px-4 py-2 bg-indigo-500 hover:bg-indigo-600 text-white text-sm font-medium rounded-lg transition-colors"
                                        onClick={() => openEditModal(record)}
                                      >
                                        Edit
                                      </button>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </Card>
            </div>
          )}
        </div>
      </main>

      {/* Modal */}
      {showModal && (
        <div className="absolute inset-0 z-50 flex items-center justify-center p-4 pt-10 h-[calc(100vh-100px)]">
          <div className="relative rounded-2xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-auto bg-blue-500" >
            {/* Modal Header#0369a1 */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-slate-200 bg-gradient-to-r from-indigo-600 to-purple-600">
              <h2 className="text-lg font-bold text-white">
                {selectedRecord ? "Edit Candidate" : "Add New Candidate"}
              </h2>
              <button
                onClick={closeModal}
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary hover:bg-white/30 text-white transition-colors"
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div className="overflow-y-auto max-h-[calc(90vh-140px)] p-6">
              <form className="space-y-4">
                {selectedRecord ? (
                  <>
                    {[
                      { id: "candidateName", label: "Candidate Name", type: "text", defaultValue: selectedRecord.candidate_name },
                      { id: "speciality", label: "Speciality", type: "text", defaultValue: selectedRecord.speciality },
                      { id: "hospital", label: "Hospital", type: "text", defaultValue: selectedRecord.hospital },
                      { id: "city", label: "City", type: "text", defaultValue: selectedRecord.city },
                      { id: "state", label: "State", type: "text", defaultValue: selectedRecord.state },
                    ].map((field) => (
                      <div key={field.id}>
                        <label className="block text-sm font-medium text-slate-700 mb-1.5">{field.label}</label>
                        <input type={field.type} id={field.id} defaultValue={field.defaultValue} className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                      </div>
                    ))}
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Status</label>
                      <select id="status" defaultValue={selectedRecord.status} className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white text-slate-800">
                        <option value="resume_forwarded">Resume Forwarded</option>
                        <option value="pipeline">Pipeline</option>
                        <option value="turned_up">Turned Up</option>
                        <option value="selected">Selected</option>
                        <option value="joined">Joined</option>
                        <option value="not_selected">Not Selected</option>
                        <option value="backout">Backout</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Expected Revenue</label>
                      <input type="number" id="expected_revenue" defaultValue={selectedRecord.expected_revenue} placeholder="Enter expected revenue (Selected only)" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Revenue</label>
                      <input type="number" id="revenue" defaultValue={selectedRecord.revenue} placeholder="Enter actual revenue (Joined only)" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-slate-700 mb-1.5">Remark</label>
                      <input type="text" id="remark" defaultValue={selectedRecord.remark || ""} placeholder="Enter remark" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                  </>
                ) : (
                  <>
                    {[
                      { id: "candidateName", label: "Candidate Name", type: "text", placeholder: "Enter candidate name" },
                      { id: "speciality", label: "Speciality", type: "text", placeholder: "Enter speciality" },
                      { id: "hospital", label: "Hospital", type: "text", placeholder: "Enter hospital" },
                      { id: "city", label: "City", type: "text", placeholder: "Enter city" },
                      { id: "state", label: "State", type: "text", placeholder: "Enter state" },
                    ].map((field) => (
                      <div key={field.id}>
                        <label className="block text-sm font-medium text-white mb-1.5">{field.label}</label>
                        <input type={field.type} id={field.id} placeholder={field.placeholder} className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                      </div>
                    ))}
                    <div>
                      <label className="block text-sm font-medium text-white mb-1.5">Status</label>
                      <select id="status" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white text-slate-800">
                        <option value="resume_forwarded">Resume Forwarded</option>
                        <option value="pipeline">Pipeline</option>
                        <option value="turned_up">Turned Up</option>
                        <option value="selected">Selected</option>
                        <option value="joined">Joined</option>
                        <option value="not_selected">Not Selected</option>
                        <option value="backout">Backout</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-white mb-1.5">Expected Revenue</label>
                      <input type="number" id="expected_revenue" placeholder="Enter expected revenue (Selected only)" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-white mb-1.5">Revenue</label>
                      <input type="number" id="revenue" placeholder="Enter actual revenue (Joined only)" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-white mb-1.5">Remark</label>
                      <input type="text" id="remark" placeholder="Enter remark" className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" />
                    </div>
                  </>
                )}
              </form>
            </div>

            {/* Modal Footer */}
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50">
              <button onClick={closeModal} className="px-5 py-2.5 text-sm font-medium text-white bg-primary border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors">
                Cancel
              </button>
              <button onClick={handleSave} className="px-5 py-2.5 text-sm font-medium text-white bg-green-800 rounded-lg hover:bg-indigo-700 transition-colors">
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default UserView;
